import {
    getAuthState,
    getEmail,
    getPhone,
    isLoading,
    isPhoneVerified as isPhoneVerifiedSelector,
} from '/b2b/authentication/state/Auth.selectors';
import { resendPhoneVerificationCode, verify } from './VerifyPhone.commands';

import { getCodeDeliveryDetails } from '/b2b/authentication/state/amplify/Amplify.selectors';

export const mapStateToProps = state => {
    const phone = getPhone(state);
    const isPhoneVerified = isPhoneVerifiedSelector(state);
    return {
        email: getEmail(state),
        phone,
        hasPhone: !!phone,
        isPhoneVerified,
        authState: getAuthState(state),
        isLoading: isLoading(state),
        codeDeliveryDetails: getCodeDeliveryDetails(state, 'PHONE'),
    };
};

export const mapDispatchToProps = { verify, resendPhoneVerificationCode };
